import { useEffect, useMemo, useState } from "react";
import Aside from "../../components/aside/aside.component";
import Footer from "../../components/footer/footer.component";
import Header from "../../components/header/header.component";
import FormModal from "./form.modal";
import { Link } from "react-router-dom";
import AlertPeriod from "../../components/alert-period/alert-period";
import usePeriod from "../../hooks/period.use";
import { LoansService } from "../../services/operation/loans.service";
import { UtilsService } from "../../services/utils";
import EmptyState from "../../components/empty-state/empty-state.component";
import Button from "../../components/button/button.component";
import { Controller, useForm } from "react-hook-form";
import moment from "moment";
import DatepickerComponent from "../../components/datepicker/datepicker.component";
import { LoanCreditsService } from "../../services/loan-credits";
import SelectComponent from "../../components/select/select.component";
import { ExcelService } from "../../utils/excel";


declare const KTComponents: any;

function LoansPage() {
  const { currentPeriod } = usePeriod();

  const defaultValues = {
    range: "",
    account: "-1",
  };

  const {
    watch,
    setValue,
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<typeof defaultValues>({
    mode: "onChange",
    defaultValues,
  });

  const [showModal, setShowModal] = useState({
    data: null,
    show: false,
  });

  const [accounts, setAccounts] = useState<any[]>([]);

  const [list, setList] = useState<any[]>([]);
  const [originalList, setOriginalList] = useState<any[]>([]);

  const totales = useMemo(() => {
    const total = list.reduce((acc: number, value: any) => acc + value.amount, 0);
    const totalInterest = list.reduce((acc: number, value: any) => acc + value.total_interest, 0);
    const paymentsCapital = list.reduce((acc: number, value: any) => acc + (value.payments_capital ? value.payments_capital.total: 0), 0);
    const paymentsInterest = list.reduce((acc: number, value: any) => acc + (value.payments_intereses ? value.payments_intereses.total: 0), 0);

    return {
      total,
      totalInterest,
      paymentsCapital,
      paymentsInterest,
    }
    
  }, [list]);

  const handleModal = (refresh?: boolean) => {
    if (refresh) {
      getList();
    }
    setShowModal({ data: null, show: false });
  };

  const getAccounts = async () => {
    const data = await LoanCreditsService.list();
    const all = { value: -1, text: "Todas las cuentas" };
    const c = data.map((row: any) => ({ value: row._id, text: row.name }));

    setAccounts([all, ...c]);
  };

  const getList = async () => {
    const data = await LoansService.list(currentPeriod._id);
    setList(data);
    setOriginalList(data);
  };

  const totalPayments = (row: any) =>
    (row.payments_capital?.total || 0) + (row.payments_intereses?.total || 0);

  const missingPayments = (row: any) => {
    const total = row.amount + row.total_interest;
    const payments = totalPayments(row);

    if (payments < total) {
      return "text-danger";
    }

    return "text-success";
  };

  const filter = (data: typeof defaultValues) => {
    const range = data.range;
    const account = data.account;

    if (!range && account === "-1") {
      return setList(originalList);
    }

    const listFiltered = originalList
      .filter((row) => {
        return account === "-1" || row.loan_credit._id === account;
      })
      .filter((row) => {
        return (
          range.length !== 2 ||
          moment(row.date).isBetween(
            moment(range[0]),
            moment(range[1]),
            "days",
            "[]"
          )
        );
      });

    setList(listFiltered);
  };

  const download = () => {
    const jsonToExport = list.map((row: any) => {
      return {
        "Fecha de deuda contraida": UtilsService.dateFormat(row.date, "DD/MM/YYYY"),
        "Cuenta": row.loan_credit?.name,
        "Total deuda": UtilsService.numberFormat(row.amount + row.total_interest),
        "Monto deuda": UtilsService.numberFormat(row.amount),
        "Intereses deuda": UtilsService.numberFormat(row.total_interest),

        "Total pagos": UtilsService.numberFormat(totalPayments(row)),
        "Pagos capital": UtilsService.numberFormat(row.payments_capital?.total || 0),
        "Pagos Intereses": UtilsService.numberFormat(row.payments_intereses?.total || 0),

        "Intereses": `${UtilsService.numberFormat(row.interest)}%`,
        "Plazo (meses)": row.total_months,
        "Condiciones": row.comments,
      }
    })

    ExcelService.fromJson(jsonToExport);
  };

  useEffect(() => {
    getAccounts();
    getList();
  }, []);

  useEffect(() => {
    KTComponents.init();
  }, [list]);

  return (
    <>
      <div className="d-flex flex-column flex-root">
        <div className="page d-flex flex-row flex-column-fluid">
          <Aside />
          <div
            className="wrapper d-flex flex-column flex-row-fluid"
            id="kt_wrapper"
          >
            <Header />
            <div
              className="content fs-6 d-flex flex-column flex-column-fluid"
              id="kt_content"
            >
              <div className="toolbar" id="kt_toolbar">
                <div className="container-fluid d-flex flex-stack flex-wrap flex-sm-nowrap">
                  <div className="d-flex flex-column align-items-start justify-content-center flex-wrap me-2">
                    <h1 className="text-gray-900 fw-bold my-1 fs-2">
                      Prestamos y créditos
                      <small className="text-muted fs-6 fw-normal ms-1" />
                    </h1>
                    <ul className="breadcrumb fw-semibold fs-base my-1">
                      <li className="breadcrumb-item text-muted">Operación</li>
                      <li className="breadcrumb-item text-gray-900">
                        Prestamos y créditos
                      </li>
                    </ul>
                  </div>
                  <div className="d-flex align-items-center flex-nowrap text-nowrap py-1">
                    <button
                      className="btn btn-primary"
                      onClick={() => setShowModal({ data: null, show: true })}
                    >
                      <i className="ki-duotone ki-plus"></i> Crear prestamo o
                      crédito
                    </button>
                  </div>
                </div>
              </div>

              <div className="container-xxl mb-5">
                <AlertPeriod />
              </div>

              <div className="post fs-6 d-flex flex-column-fluid" id="kt_post">
                <div className="container-xxl">
                  <div className="card mb-4">
                    <div className="card-body">
                      <h4 className="mb-6">
                        Filtros <i className="bi bi-funnel-fill" />
                      </h4>

                      <div className="d-flex align-items-end column-gap-4">
                        <div className="flex-grow-1">
                          <Controller
                            name="range"
                            control={control}
                            rules={{ required: false }}
                            render={({
                              field: { onChange, value },
                              fieldState: { error },
                            }) => {
                              let valueFormatted = "";

                              if (Array.isArray(value) && value.length === 2) {
                                const start = moment(value[0]).format(
                                  "DD-MM-YYYY"
                                );
                                const end = value[1]
                                  ? moment(value[1]).format("DD-MM-YYYY")
                                  : "";
                                valueFormatted = `Del ${start} al ${end}`;
                              }

                              return (
                                <>
                                  <DatepickerComponent
                                    label="Rango de fechas"
                                    errors={error}
                                    onChange={onChange}
                                    value={valueFormatted}
                                    mode="range"
                                    disable={[
                                      {
                                        from: moment()
                                          .add(1, "days")
                                          .format("YYYY-MM-DD"),
                                        to: moment()
                                          .add(1, "years")
                                          .format("YYYY-MM-DD"),
                                      },
                                    ]}
                                  />
                                </>
                              );
                            }}
                          />
                        </div>
                        <div className="flex-grow-1">
                          <SelectComponent
                            label="Cuentas"
                            data={accounts}
                            {...register("account", { required: false })}
                            errors={errors.account}
                          />
                        </div>
                        <div className="">
                          <Button
                            className="btn btn-primary"
                            onClick={handleSubmit(filter)}
                          >
                            Filtrar
                          </Button>
                        </div>
                        <div className="nowrap">
                          <Button className="btn btn-light-primary" onClick={download}>
                            <i className="bi bi-download"></i>
                            Descargar
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div className="mb-4 d-flex column-gap-4">
                    <div className="card flex-grow-1 text-center">
                      <div className="card-body">
                        <div className="fs-2x fw-bold">
                          $ {UtilsService.numberFormat(totales.total)}
                        </div>
                        <div className="fs-4 fw-semibold text-gray-500">
                          Total deuda
                        </div>
                      </div>
                    </div>
                    <div className="card flex-grow-1 text-center">
                      <div className="card-body">
                        <div className="fs-2x fw-bold">
                          $ {UtilsService.numberFormat(totales.totalInterest)}
                        </div>
                        <div className="fs-4 fw-semibold text-gray-500">
                          Total intereses
                        </div>
                      </div>
                    </div>
                    <div className="card flex-grow-1 text-center">
                      <div className="card-body">
                        <div className="fs-2x fw-bold">
                          $ {UtilsService.numberFormat(totales.paymentsCapital)}
                        </div>
                        <div className="fs-4 fw-semibold text-gray-500">
                          Abono a capital
                        </div>
                      </div>
                    </div>
                    <div className="card flex-grow-1 text-center">
                      <div className="card-body">
                        <div className="fs-2x fw-bold">
                          $ {UtilsService.numberFormat(totales.paymentsInterest)}
                        </div>
                        <div className="fs-4 fw-semibold text-gray-500">
                          Abono de interés
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-body py-4">
                      <div
                        className="dt-container dt-bootstrap5 dt-empty-footer"
                        id="kt_table_users_wrapper"
                      >
                        <div className="table-responsive" id="">
                          <table
                            className="table align-middle table-row-dashed fs-6 gy-5 dataTable"
                            id="loans-table"
                          >
                            <thead>
                              <tr
                                className="text-start text-muted fw-bold fs-7 text-uppercase gs-0"
                                role="row"
                              >
                                <th
                                  aria-label="Joined Date: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span
                                    className=""
                                    
                                  >
                                    Fecha de deuda contraida
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Joined Date: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span
                                    className=""
                                    
                                  >
                                    Cuenta
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Joined Date: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span
                                    className=""
                                    
                                  >
                                    Total de deuda contraída
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Joined Date: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span
                                    className=""
                                    
                                  >
                                    Pagos
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Joined Date: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span
                                    className=""
                                    
                                  >
                                    Condiciones
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Actions"
                                  className="text-end min-w-100px dt-orderable-none"
                                  colSpan={1}
                                  rowSpan={1}
                                >
                                  <span className="">
                                    Acciones
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                              </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold">
                              {list.map((row) => (
                                <tr key={row._id}>
                                  <td>
                                    {UtilsService.dateFormat(
                                      row.date,
                                      "DD/MM/YYYY"
                                    )}
                                  </td>
                                  <td>{row.loan_credit.name}</td>
                                  <td className="align-content-start">
                                    <p className="nowrap m-0 text-gray-800">
                                      Total: ${" "}
                                      {UtilsService.numberFormat(
                                        row.amount + row.total_interest
                                      )}{" "}
                                    </p>
                                    <p className="nowrap m-0">
                                      Monto: ${" "}
                                      {UtilsService.numberFormat(row.amount)}{" "}
                                    </p>
                                    <p className="nowrap m-0">
                                      Intereses: ${" "}
                                      {UtilsService.numberFormat(
                                        row.total_interest
                                      )}{" "}
                                    </p>
                                  </td>
                                  <td className="align-content-start">
                                    <p
                                      className={`nowrap m-0 ${missingPayments(row)}`}
                                    >
                                      Total: ${" "}
                                      {UtilsService.numberFormat(
                                        totalPayments(row)
                                      )}{" "}
                                    </p>
                                    <p className="nowrap m-0">
                                      Capital: ${" "}
                                      {UtilsService.numberFormat(
                                        row.payments_capital?.total || 0
                                      )}{" "}
                                    </p>
                                    <p className="nowrap m-0">
                                      Intereses: ${" "}
                                      {UtilsService.numberFormat(
                                        row.payments_intereses?.total || 0
                                      )}{" "}
                                    </p>
                                  </td>
                                  <td className="align-content-start">
                                    <p className="m-0">
                                      Interés anual:{" "}
                                      {UtilsService.numberFormat(row.interest)}%
                                    </p>
                                    <p className="m-0 mb-2">
                                      Plazo (meses): {row.total_months}
                                    </p>
                                    <p className="m-0">{row.comments}</p>
                                  </td>
                                  <td className="text-end">
                                    <button
                                      className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm"
                                      data-kt-menu-placement="bottom-end"
                                      data-kt-menu-trigger="click"
                                    >
                                      Acciones
                                      <i className="ki-duotone ki-down fs-5 ms-1" />
                                    </button>
                                    <div
                                      className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4"
                                      data-kt-menu="true"
                                    >
                                      <div className="menu-item px-3">
                                        <Link
                                          to="payments"
                                          className="menu-link px-3 text-start"
                                          state={{ loan: row }}
                                        >
                                          Depósitos
                                        </Link>
                                        <Link
                                          to="."
                                          className="menu-link px-3 text-start"
                                          onClick={() =>
                                            setShowModal({ data: row, show: true })
                                          }
                                        >
                                          Editar
                                        </Link>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                            <tfoot />
                          </table>

                          {list.length === 0 && <EmptyState />}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>

      <FormModal
        show={showModal.show}
        data={showModal.data}
        setShow={handleModal}
      />
    </>
  );
}

export default LoansPage;
